
<template>

    <div class="container-fluid" v-show="isVisible == true">
      <div v-for="step in onboardingdata" class="container-fluid wizardpanel animated fadeIn" v-bind:id="'wizardstep' + step.id">
        <div class="row">
          <div class="col-12">
            <onboarding-question v-bind:step="step" v-bind:element="step.question"></onboarding-question>
          </div>
        </div>
        <div v-for="answer in step.answers" class="row">
          <div class="col-12 mt-3">
            <onboarding-answer @removeanswer="removeanswer" v-bind:removable="answer.removable && answer.removable == true" v-bind:step="step" v-bind:element="answer" @goto="goto"></onboarding-answer>
          </div>
        </div>
        <div class="row" v-show="step.input != null && typeof(step.input) != 'undefined'">
          <div class="col-12 mt-3">
            <onboarding-input v-bind:limit="step.input && step.input.limit" v-bind:step="step" v-bind:element="step.input" @goto="goto" @inputclick="inputclickfunction"></onboarding-input>
          </div>
        </div>
        <div class="row" v-show="step.qrcode != null && typeof(step.qrcode) != 'undefined'">
          <div class="col-6 mt-3">
            <onboarding-qrcode v-bind:limit="step.qrcode && step.qrcode.limit" v-bind:step="step" v-bind:element="step.qrcode" @goto="goto"></onboarding-qrcode>
          </div>
        </div>
        <div class="row" v-for="button in step.buttons">
          <div class="col-12 mt-3">
            <onboarding-button limit="button.limit" v-bind:step="step" v-bind:element="button" @buttonclick="buttonclickFunction" @goto="goto"></onboarding-button>
          </div>
        </div>

      </div>
      </div>

</template>

<script>
  var onboardingdata = [
    {
      id: 1,
      question: { text: "What do you want your QR code to do?", animation: "animated duration-1 fadeIn" },
      answers: [
        { text: "Lead to a questionaire", goto: 10, animation: "animated duration-1 rubberBand" },
        { text: "Report a problem", goto: 20, animation: "animated duration-2 tada" },
        { text: "Book a resource", goto: 30, animation: "animated duration-3 bounceIn" },
        { text: "Something else", goto: 40, animation: "animated duration-3 bounceIn" },
      ],
      buttons: [],
    },


    {
      id: 10,
      question: { text: "Add a question", animation: "animated duration-2 fadeIn" },
      answers: [],
      input: { type: 'task', text: "Enter a question to ask your users", suggestions: ["Do you want to buy my car?", "How much do you want to pay?"], animation: "animated duration-2 fadeIn" },
      buttons: [{id:'', text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 90, limit:1 }],
    },
    

    {
      id: 20,
      question: { text: "Do you want your users to check something before sending you an problem report?" },
      answers: [],
      input: { type: 'task', text: "What is this..", suggestions: ["Did you check the internet connection?", "Is the lan connection blinking green?"], goto: 21, animation: "animated duration-2 fadeIn" },
      buttons: [{ id: '',  text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 21, limit: 1 }],
     },
    {
      id: 21,
      question: { text: "Do you want your users to provide more information?" },
      answers: [],
      input: { type: 'task', text: "Something", suggestions: ["How should I contact you?"], goto: 90, animation: "animated duration-2 fadeIn" },
      buttons: [{ id: '',  text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 90, limit: 1 }],
    },



    {
      id: 30,
      question: { text: "booking.." },
      answers: [
        { text: "Yes, I would like to book", goto: 90, animation: "animated duration-2 fadeIn" },
      ],
      buttons: [{ id: '', text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 90, limit: 1 }],
    },



    {
      id: 40,
      question: { text: "Tell us your idea and we can do some cool stuff together!", animation: "animated duration-1 fadeIn" },
      answers: [],
      input: { type: 'username', text: "Tell us your idea here", suggestions: [], goto: 90, animation: "animated duration-2 fadeIn" },
      buttons: [{ id: '',  text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 41, limit: 1 }],
    },
    {
      id: 41,
      question: { text: "How can we contact you?", animation: "animated duration-1 fadeIn" },
      answers: [],
      input: { type: 'username', isEmail: true, text: "Tell us how to contact you here", suggestions: [], goto: 90, animation: "animated duration-2 fadeIn", limit:1 },
      buttons: [{ id: '',  text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 42, limit: 1 }],
    },
    {
      id: 42,
      question: { text: "Thank you!, we will get back to you as soon as possible", animation: "animated duration-1 fadeIn" },
      answers: [],
      buttons: [{ id: '',  text: "Start over &raquo;", animation: "animated duration-2 fadeIn", goto: 1 }],
    },
    
    {
      id: 90,
      question: { text: "What email do you want us to send the answers?", animation: "animated duration-2 fadeIn" },
      answers: [],
      input: { type: 'task', isEmail: true, text: "Email", suggestions: [], goto: 100, animation: "animated duration-2 fadeIn", limit:1 },
      buttons: [{ id: 'create',  text: "Next &raquo;", animation: "animated duration-2 fadeIn", goto: 100, limit: 1 }],
    },

    {
      id: 100,
      question: { text: "Thank you, here is your QR code", animation: "animated duration-2 fadeIn" },
      answers: [],
      buttons: [],
    },

  ]

  /*
  With start over button
 {
      id: 100,
      question: { text: "Thank you, here is your QR code", animation: "animated duration-2 fadeIn" },
      answers: [],
      buttons: [{ id: 'reset', text: "Create another QR code? &raquo;", animation: "animated duration-2 fadeIn"}],
    },

*/

  import ModalDefault from "../modals/modal-default.vue";
  import OnBoardingQuestion from "../onboarding/onboarding-question.vue";
  import OnBoardingAnswer from "../onboarding/onboarding-answer.vue";
  import OnBoardingInput from "../onboarding/onboarding-input.vue";
  import OnBoardingButton from "../onboarding/onboarding-button.vue";


  export default {
    name: 'onboarding-qrblob',
    components: {
      ModalDefault,
      OnBoardingQuestion,
      OnBoardingAnswer,
      OnBoardingInput,
      OnBoardingButton
    },
    props: {
      inputclick: {
        required: false,
        type: String,
        default: ''
      },
      buttonclick: {
        required: false,
        type: String,
        default: ''
      },
      state: {
        required: false,
        type: String,
        default: ''
      },
    },
    data() {
      return {
        onboardingdata,
        isVisible: false,
        copy: null,
      }
    },
    methods: {
      removeanswer(element, step) {
        var tmp = [];
        for (var i = 0; i < step.answers.length; i++) {
          if (step.answers[i] != element) {
            tmp.push(step.answers[i]);
          }
        }
        step.answers = tmp;
      },
      buttonclickFunction(element, step) {
        if (this.inputclick != null) {
          eval(this.buttonclick + "(element, step)")
        }
      },
      inputclickfunction(answer, element, step) {
        var newAnswer = { text: answer, animation: "animated duration-1 rubberBand", removable: true }
        step.answers.push(newAnswer);

        if (this.inputclick != null) {
          eval(this.inputclick + "(answer, element)")
        }
      },
      goto(step) {
        this.activateStep(step);
      },

      activateStep(step) {
        $(".wizardpanel").hide();
        $("#wizardstep" + step).show();

        $("#wizardstep" + step + " .question").addClass("hidden-onboarding");
        $("#wizardstep" + step + " .answer").addClass("hidden-onboarding");
        $("#wizardstep" + step + " .onboardinginput").addClass("hidden-onboarding");
        $("#wizardstep" + step + " .onboardingbutton").addClass("hidden-onboarding");

        setTimeout(
          function () {
            $("#wizardstep" + step + " .question").removeClass("hidden-onboarding");
            $("#wizardstep" + step + " .answer").removeClass("hidden-onboarding");
            $("#wizardstep" + step + " .onboardinginput").removeClass("hidden-onboarding");
            $("#wizardstep" + step + " .onboardingbutton").removeClass("hidden-onboarding");
            
          }, 200
        )
      },
      open() {
        this.isVisible = true;
      },
      close() {
        this.isVisible = false;
      },
      getStep(id) {
        var tmp = null;

        var data = this.onboardingdata;
        for (var i = 0; i < data.length; i++) {
          if (data[i].id == id)
            tmp = data[i];
        }
        return tmp;
      },
      update() {
        this.$forceUpdate();
      },
      getData() {
        return this.onboardingdata;
      },
      reset() {
        this.onboardingdata = JSON.parse(JSON.stringify(this.copy));
      }
    },
    created() {

    },
    mounted() {

      this.copy = JSON.parse(JSON.stringify(this.onboardingdata));

      if (this.state == 'open') {
        this.open();
      }
      this.activateStep("1")
    }
  }
</script>

<style scoped>
  .delay-1 {
    animation-delay: 1s;
  }

  .delay-2 {
    animation-delay: 2s;
  }

  .delay-3 {
    animation-delay: 3s;
  }

  .delay-4 {
    animation-delay: 4s;
  }

  .duration-1 {
    animation-duration: 1s;
  }

  .duration-2 {
    animation-duration: 2s;
  }

  .duration-3 {
    animation-duration: 3s;
  }

  .duration-4 {
    animation-duration: 4s;
  }

  .duration-5 {
    animation-duration: 5s;
  }

  .duration-6 {
    animation-duration: 6s;
  }

  .duration-7 {
    animation-duration: 7s;
  }

  .duration-8 {
    animation-duration: 8s;
  }

  .duration-9 {
    animation-duration: 9s;
  }

  .duration-10 {
    animation-duration: 10s;
  }


</style>

<style>
  .hidden-onboarding {
    /*display:none;*/
    opacity: 0;

  }

  .modalmargin .modal-dialog {
    margin-top: 5vh;
    height: 80vh;
    min-height: 75%;
    display: table;
    width: 75%;
  }

  .modalmargin .modal-content {
    height:100%;
    display:inline-table;
  }

  .modalmargin .modal-body {
    display: inline-table;
    height: calc(100% - 70px);
    width:100%
  }

 
  .modalmargin {
    height: 100vh;
  }


  @media (max-width: 768px) {
    .modalmargin {
      margin: 30px !important;
      width: unset !important;
      height: 100vh;
    }
    .modalmargin .modal-dialog {
      height: calc(100vh - 55px) !important;
      width: 100%;
    }
  }

  

</style>



// WEBPACK FOOTER //
// src/components/onboarding/onboarding-qrblob.vue